<template>
  <div>
    <el-radio-group v-model="dataModel" :disabled="disabled" :size="size">
      <el-radio
        v-for="(item, index) in options"
        :key="item.value + index"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
// 审批结果
export default {
  name: "Flag",
  props: {
    value: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      options: [
        {
          value: "1",
          label: "通过"
        },
        {
          value: "2",
          label: "驳回"
        }
      ]
    };
  },
  computed: {
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    }
  },
  watch: {
    value(val) {
      this.dataModel = val;
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  }
};
</script>
